import { create } from 'zustand';

/**
 * First-run onboarding flags (spec 01 disclaimer + Phase 2 setup guide).
 * Device-local, persisted in localStorage. Both dialogs are re-openable from
 * settings (OM).
 */
const ACK_KEY = 'los.disclaimerAck';
const SETUP_KEY = 'los.setupSeen';

function flag(key: string): boolean {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}
function setFlag(key: string): void {
  try {
    localStorage.setItem(key, '1');
  } catch {
    /* ignore */
  }
}

interface OnboardingState {
  showDisclaimer: boolean;
  showSetup: boolean;
  acceptDisclaimer: () => void;
  openDisclaimer: () => void;
  /** Show the setup guide the first time (or force = re-open from settings). */
  maybeShowSetup: (force?: boolean) => void;
  closeSetup: () => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  showDisclaimer: !flag(ACK_KEY),
  showSetup: false,

  acceptDisclaimer: () => {
    setFlag(ACK_KEY);
    set({ showDisclaimer: false });
  },
  openDisclaimer: () => set({ showDisclaimer: true }),

  maybeShowSetup: (force = false) => {
    if (force) {
      set({ showSetup: true });
      return;
    }
    if (!flag(SETUP_KEY)) {
      setFlag(SETUP_KEY);
      set({ showSetup: true });
    }
  },
  closeSetup: () => set({ showSetup: false }),
}));
